import React, { useState } from "react"
import { Button, CircularProgress } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import GetAppIcon from "@material-ui/icons/GetApp"
import PropTypes from "prop-types"
import { pdf } from "@react-pdf/renderer"
import { saveAs } from "file-saver"
import ClientPdf from "../ClientPdf/index"
import SingleCrewPdf from "../SingleCrewPdf/index"

const useStyles = makeStyles({
  label: {
    display: "flex",
    justifyContent: "space-between",
  },
})

const DownloadPdfButton = ({ type = "", data = {}, disabled = false, client = false }) => {
  const classes = useStyles()
  const [loadingPdf, setLoadingPdf] = useState(false)

  const generatePdf = async () => {
    setLoadingPdf(true)
    if (type.toLowerCase() === "estimate" || type.toLowerCase() === "invoice") {
      const blob = await pdf(
        <ClientPdf data={{ ...data, type: type }} client={client} />
      ).toBlob()
      saveAs(blob, `client-${type.toLowerCase()}.pdf`)
    } else {
      const blob = await pdf(
        <SingleCrewPdf data={{ ...data, type: type }} />
      ).toBlob()
      saveAs(blob, `crew-${type.toLowerCase()}.pdf`)
    }
    setLoadingPdf(false)
  }

  return (
    <Button
      size="small"
      variant="outlined"
      style={{
        display: "flex",
        border: "0px solid #EBEBEB",
        borderRadius: "5px",
        backgroundColor: "#EBEBEB",
        flexWrap: "none",
      }}
      classes={{ label: classes.label }}
      onClick={generatePdf}
      disabled={loadingPdf || disabled}
    >
      <GetAppIcon style={{ alignSelf: "flex-start" }} />
      {loadingPdf ? (
        <CircularProgress
          size={15}
          style={{
            margin: "0 36px",
            color: "rgba(0, 0, 0, 0.87)",
            alignSelf: "center",
          }}
        />
      ) : (
        client ? "Download Client PDF" : "Download PDF"
      )}
    </Button>
  )
}

DownloadPdfButton.propTypes = {
  type: PropTypes.oneOf(["estimate", "invoice", "deal-memo", "crew-bill"])
    .isRequired,
  data: PropTypes.object,
  disabled: PropTypes.bool,
}

export default DownloadPdfButton
